/**
 * UserDetailsFields Component
 * 
 * Renders name/email input fields for uploaders.
 * Auto-hides when user is authenticated via Supabase (email is auto-filled).
 * 
 * Usage:
 * <UserDetailsFields
 *   name={name}
 *   setName={setName}
 *   email={email}
 *   setEmail={setEmail}
 *   focusedField={focusedField}
 *   setFocusedField={setFocusedField}
 *   styles={styles}
 * />
 */

import React from "react";
import { useAuthUser } from "../../hooks/useAuthUser";

export function UserDetailsFields({
  name,
  setName,
  email,
  setEmail,
  focusedField,
  setFocusedField,
  styles,
}) {
  const { isAuthenticated } = useAuthUser();

  // When authenticated, don't render the fields at all
  // The email will be auto-filled from auth context in the parent component
  if (isAuthenticated) {
    return null;
  }

  return (
    <div style={styles.grid2}>
      <div style={styles.field}>
        <label style={styles.label} htmlFor="name">
          Your Name
        </label>
        <input
          type="text"
          id="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onFocus={() => setFocusedField("name")}
          onBlur={() => setFocusedField(null)}
          style={{
            ...styles.input,
            ...(focusedField === "name" ? styles.inputFocus : {}),
          }}
          placeholder="Your full name"
          required
        />
      </div>

      <div style={styles.field}>
        <label style={styles.label} htmlFor="email">
          Your Email
        </label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onFocus={() => setFocusedField("email")}
          onBlur={() => setFocusedField(null)}
          style={{
            ...styles.input,
            ...(focusedField === "email" ? styles.inputFocus : {}),
          }}
          placeholder="you@example.com"
          required
        />
      </div>
    </div>
  );
}

export default UserDetailsFields;
